import React, { Component } from "react"
import PropTypes from "prop-types"
import DrilldownShape from "../../state/shapes/DrilldownShapes/DrilldownShape"
import Widget from "../layout/widget/Widget"
import DrilldownBarChart from "../charts/generic/DrilldownBarChart"
import ShowAllButton from "./ShowAllButton"

class Top5LD extends Component {
  state = {
    chartIsScrollable: false
  }

  seeAllData = () => {
    this.setState({
      chartIsScrollable: !this.state.chartIsScrollable
    })
  }

  render() {
    const { exportEndpoint, data, appliedFilters, subtitleKey, sampleSize } = this.props
    const titleKey="Widgets.Top5LD.Title"
    return (
      <Widget
        columns={1}
        titleKey={titleKey}
        helpKey="Widgets.Top5LD.Help"
        exportEndpoint={exportEndpoint}
        appliedFilters={appliedFilters}
        subtitleKey={subtitleKey}
        sampleSize={sampleSize}
      >
        <DrilldownBarChart
          data={data}
          yAxisTitle="Widgets.Top5LD.Responses"
          scrollbarEnabled={this.state.chartIsScrollable}
          titleKey={titleKey}
          subtitleKey={subtitleKey}
        />
        <ShowAllButton onClick={this.seeAllData} isActive={this.state.chartIsScrollable} />
      </Widget>
    )
  }
}

Top5LD.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape(DrilldownShape).isRequired,
  exportEndpoint: PropTypes.string.isRequired,
  subtitleKey: PropTypes.string,
  sampleSize: PropTypes.object
}

export default Top5LD



// WEBPACK FOOTER //
// ./src/components/widgets/Top5LD.jsx